export class GlobalConstants{

    public static splashScreen:boolean = false;
    public static timeoutRefresh:number = 9000;
    
  //  public static url:string = "https://localhost:8443/";
    
  public static url:string = "https://prefeituradetresrios.com.br:8443/"; 
}